import { render } from "./ComponentDiretorio.vue?vue&type=template&id=fe0e41ee&scoped=true"
import script from "./ComponentDiretorio.vue?vue&type=script&lang=js"
export * from "./ComponentDiretorio.vue?vue&type=script&lang=js"

import "./ComponentDiretorio.vue?vue&type=style&index=0&id=fe0e41ee&scoped=true&lang=css"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0e41ee"]])

export default __exports__